import { gql } from '@apollo/client';

export const BLOB_FRAGMENT = gql`
  fragment blobFields on Blob {
    id
    contentType
    filename
    key
    s3URL
  }
`;

export const DOCUMENT_FRAGMENT = gql`
  fragment documentFields on Document {
    id
    blob {
      ...blobFields
    }
    creator
    key
    name
    type
  }
  ${BLOB_FRAGMENT}
`;